import moment from 'moment-timezone';
import * as Yup from 'yup';
import { getDateFromString } from '../utils/DateFormatter';
// const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;
// eslint-disable-next-line import/prefer-default-export
export var campaignOversightFormValidationSchema = function (dialerDefaults, scheduleExecution) {
    return Yup.object().shape({
        initialCpaMode: Yup.string().matches(/^(?!(none)$)/, 'Required'),
        initialCallsPerAgent: Yup.number()
            .test('mode', "Minimum CPA is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin), function (val) {
            if ((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.CampaignMode) === 'power' &&
                typeof val === 'number') {
                return Number(val) >= Number("" + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMin));
            }
            else {
                return true;
            }
        })
            .test('mode', "Maximum CPA is  " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMax), function (val) {
            if ((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.CampaignMode) === 'power' &&
                typeof val === 'number') {
                return Number(val) <= Number("" + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialCpaMax));
            }
            else {
                return true;
            }
        }),
        initialPacing: Yup.number()
            .required('Required')
            .when('initialCpaMode', {
            is: 'samples',
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMin, "Inital Pacing Samples Minimum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMax, "Inital Pacing Samples Maximum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingSamplesMax))
        })
            .when('initialCpaMode', {
            is: 'duration',
            then: Yup.number()
                .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMin, "Inital Pacing Duration Minimum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMin))
                .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMax, "Inital Pacing Duration Maximum is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.InitialPacingDurationMax))
        }),
        aBAIncrement: Yup.number()
            .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMin, "Minimum Increment is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMin))
            .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMax, "Maximum Increment is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbandonmentIncrementMax))
            .required('Required'),
        cPAModifier: Yup.number()
            .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMin, "Minimum Modifier is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMin))
            .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMax, "Maximum Modifier is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.CpaModifierMax))
            .required('Required'),
        aBACalculation: Yup.string().matches(/^(?!(none)$)/, 'Required'),
        aBATargetRate: Yup.number()
            .test('mode', "Minimum ABA Target Rate is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMin), function (val) {
            if ((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.CampaignMode) === 'power' &&
                typeof val === 'number') {
                return Number(val) >= Number("" + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMin));
            }
            else {
                return true;
            }
        })
            .test('mode', "Maximum ABA Target Rate is  " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMax), function (val) {
            if ((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.CampaignMode) === 'power' &&
                typeof val === 'number') {
                return Number(val) <= Number("" + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.AbaTargetRateMax));
            }
            else {
                return true;
            }
        }),
        concurrentCalls: Yup.number()
            .min(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMin, "Minimum Max Concurrent Calls is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMin))
            .max(dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMax, "Maximum Max Concurrent Calls is " + (dialerDefaults === null || dialerDefaults === void 0 ? void 0 : dialerDefaults.ConcurrentCallsMax)),
        weight: Yup.number()
            .min(0, 'Minimum Priority is 0')
            .max(100, 'Maximum Priority is 100')
            .required('Required'),
        endTime: Yup.string()
            .matches(/^(?!(none)$)/, 'Required')
            .required('Required')
            .test('is-greater', 'Must be later than the current time.', function (value) {
            var now = new Date();
            var oldEndDate = new Date((scheduleExecution === null || scheduleExecution === void 0 ? void 0 : scheduleExecution.EndTime) || 0);
            var newEndDate = getDateFromString(oldEndDate, value);
            return moment(newEndDate).isAfter(moment(now));
        })
    });
};
//# sourceMappingURL=CampaignOversightValidation.js.map